// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import { Link } from 'react-router-dom';

import {
  selectCartUUID,
  selectOneProductErrors,
  updateProductAndGetCartOrNotify,
  type DecoratedProduct,
} from '@gandi/cart';

import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { PassCreateDetails } from './PaasCreateDetails';
import WebHostingCreate from './WebHostingCreate';
import ProductItem from './components/ProductItem';

import { DurationRow } from './components/Rows';

import type { GandiFormSelectOption } from './types';

/* Hosting Product Decision - Do Not Touch */
const durationUnit = 'm';
const durations = [1, 3, 6, 12];

type Props = {
  product: DecoratedProduct,
};

export function PaasCreate({ product }: Props): React.Node {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, {
      productId: product.id,
    }),
  );

  const cartId = useAppSelector(selectCartUUID);

  if (product.payload.product_name === 'webhosting')
    return <WebHostingCreate product={product} />;

  const handleDurationChange: (
    selectedOption: GandiFormSelectOption<string>,
  ) => void = (selectedOption: GandiFormSelectOption<string>) => {
    const duration = parseInt(selectedOption.value, 10);
    const newPayload = { ...product.payload, duration };

    dispatch(updateProductAndGetCartOrNotify(__, product.id, newPayload));
  };

  const editPath = `/simplehosting/legacy/${cartId}/${product.id}`;

  const label = __('Web Hosting');

  const priceBeforeTaxes = product.total?.before_taxes;

  const durationInitialValue = product.payload.duration;

  return (
    <ProductItem
      key={`${product.id}-row`}
      productId={product.id}
      label={label}
      detail={undefined}
      errors={productErrors}
      footer={
        !!durationInitialValue && (
          <DurationRow
            productId={product.id}
            disabledOption={!!product.isWorking}
            // $FlowFixMe[incompatible-type-arg] - number is number|string
            onChange={handleDurationChange}
            value={durationInitialValue}
            showOption={!product.payload.trial}
            unit={durationUnit}
            values={durations}
            total={
              product.isWorking ? undefined : priceBeforeTaxes || Number.NaN
            }
          >
            <Link to={editPath}>{__('Change configuration')}</Link>
          </DurationRow>
        )
      }
    >
      <PassCreateDetails product={product} />
    </ProductItem>
  );
}
